import { useState } from 'react';
import { sendLoginPayload } from 'account-portal-library/lib/emailSignIn';

import AppVars from './../../AppVars';
import Logger from '../../Logger.js';

import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';

import LoadingGif from '../../static/images/loading.gif';
import Logo from '../../static/images/Toyota-Logo.svg';
import { useEffect } from 'react';
import navigateWithAnalytics from '../../analytics/navigateWithAnalytics.js';

const appVars = AppVars.getInstance();
const logger = Logger.getInstance();

const ACCOUNT_LOCKED_URL = "/accountlocked";
const UNKNOWN_ERROR_URL = "/unknownerror";

export function maskPhoneNumber(phoneNumber) {
    // Remove all non-digits from the phone number string
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    let masked = '';
    for (let i = 0; i < digitsOnly.length - 2; i++) {
        masked += '×';
    }
    masked += digitsOnly.slice(-2);
    let formatted = '';
    if (masked.length === 10) {
        formatted = "+× " + masked;
    } else if (masked.length === 11) {
        formatted = "+" + masked.slice(0, 1) + ' ' + masked.slice(1);
    } else {
        formatted = masked;
    }
    return formatted;
}

export function maskEmail(email) {
    if (!email || typeof email !== "string" || !email.includes("@")) {
        return email;
    }
    const [user, domain] = email.split("@");
    if (user.length <= 3) {
        return user[0] + "×".repeat(user.length - 1) + "@" + domain;
    }
    const maskedUser = user.slice(0, 3) + "×".repeat(Math.min(user.length - 3, 6));
    return maskedUser + "@" + domain;
}

const MfaSelectPage = ({ style = 'TO', savePayload, payload, saveStep, username, phoneNumber }) => {
    const [loading, setLoading] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [mobile, setMobile] = useState(phoneNumber);
    const [email, setEmail] = useState(username);
    const [choices, setChoices] = useState([]);

    const choicesUI = {
        "Validate with Password": "Validate with Password",
        "Email Code": `Send code to: ${email}`,
        "Text To Phone": `Text a code to: ${mobile}`
    }

    useEffect(() => {
        console.log("Inside MFA Select Component !");
        if (payload?.callbacks?.[0]?.output?.[1]?.name === "choices") {
            setChoices([...(payload?.callbacks?.[0]?.output?.[1]?.value ?? [])]);
        }
    }, []);

    const chooseCollection = async () => {
        try {
            const url = appVars.getBaseUrl() + "/" + appVars.getName() + '/json' + appVars.getRealm() + '/authenticate';
            const headers = {
                'Accept-API-Version': 'resource=2.1',
                'Content-Type': 'application/json'
            }
            const params = {
                'authIndexType': 'service',
                'authIndexValue': appVars.getMFATree()
            }
            payload.callbacks[0].input[0].value = selectedOption;
            const choiceResponse = await sendLoginPayload(payload, url, headers, params);
            setLoading(false);
            if (choiceResponse.status !== 200) {
                throw choiceResponse.response;
            }
            handleSuccess(choiceResponse.response);
        } catch (errorResponse) {
            console.log("Error -> ", errorResponse);
            handleFailure(errorResponse);
        }
    }

    const handleSuccess = async (loginResponse) => {
        if (!loginResponse.callbacks) {
            console.log("failure or session expired");
            navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
        } else {
            savePayload(loginResponse);
            if (selectedOption === "0") {
                if (choices[0] === "Text To Phone") {
                    saveStep("TEXT_CODE");
                } else {
                    saveStep("PASSWORD");
                }
            }
            else {
                saveStep("EMAIL_CODE");
            }
        }
    }

    const handleFailure = (loginResponse) => {
        const failureUrl = loginResponse.failureUrl
        //If invalid credentials
        if (failureUrl === ACCOUNT_LOCKED_URL) {
            setLoading(false)
            navigateWithAnalytics(ACCOUNT_LOCKED_URL, "error-redirect", "auto");
        }
        else {
            if (loginResponse.message == 'Session has timed out') {
                window.location.href = "/";
            } else {
                console.log(loginResponse.message)
                navigateWithAnalytics(UNKNOWN_ERROR_URL, "error-redirect", "auto");
            }
        }
    }

    const goNext = async () => {
        if (selectedOption !== "") {
            setLoading(true);
            chooseCollection();
        }
    }

    return <>
        <div className="select-container">
            <div className="relative login-box">
                <img src={Logo} className="login-logo__TO absolute" alt="Toyota"></img>
                <div className="title__TO left">Select an option</div>
                <div className="sign-in-mfa-grid">
                    <div className="message__TO left" style={{ 'marginBottom': '0px' }}>Your security is important to us. Please select an option below to verify your identity.</div>
                </div>
                <div className='select-form'>
                    <div className='select-form-choice'>
                        <input type="radio" id="text" name="mfa_radio" value="0" onClick={(e) => { setSelectedOption(e.target.value) }} />
                        <label className='mfa_input_label' htmlFor="text">{choicesUI[choices[0]]}</label>
                    </div>
                    <div className='select-form-choice'>
                        <input type="radio" id="call" name="mfa_radio" value="1" onClick={(e) => { setSelectedOption(e.target.value) }} />
                        <label className='mfa_input_label' htmlFor="call">{choicesUI[choices[1]]}</label>
                    </div>
                </div>
                <div className='mfa-button-group'>
                    <Button bsPrefix="login-button-outline__TO button-duration" type="submit" onClick={() => window.location.href = "https://support.toyota.com/s/?language=en_US"}>Get help with login</Button>
                    <Button bsPrefix={selectedOption !== "" ? "login-button__TO" : "login-button-disabled__TO"} type="submit" onClick={goNext}>Next Step</Button>
                </div>
            </div>
            <div className='disclaimer'>
                By clicking Next Step above, you confirm that you are the owner or primary user of the mobile phone number provided. You agree to receive automated text messages to confirm your phone number. Message and data rates may apply.
            </div>
        </div>
        <Image data-testid="loadingGIF" className={`working ${loading ? "" : "none"}`} id="loadingGIF" src={LoadingGif} aria-hidden="true" />
    </>
}

export default MfaSelectPage; 